import React, { ReactElement } from 'react';
import './dropdownListButtons.scss';
import { useLocation, useParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Uuid from '../../../model/Uuid';
import { useClient } from '../../../context/ClientStatusContext';
import { assignMe } from '../../../client/assignMeClient';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import bookmark from '../icons/bookmark.svg';
import Secured from '../../Secured';
import UserRole from '../../../model/currentuser/UserRole';
import { processInCorrectStates } from '../../../function/permissions';
import { useUserContext } from '../../../context/UserContext';

interface Props {
  assignedList: Array<Uuid>;
  setAssignedList: (assignedList: Array<Uuid>) => void;
  reloadPripomienkaList(): void;
  reloadFilterData(): void;
  setOpenDropdown: (open: boolean) => void;
}

const AssignMePripomienkaListButton = ({
  assignedList,
  setAssignedList,
  reloadPripomienkaList,
  reloadFilterData,
  setOpenDropdown,
}: Props): ReactElement => {
  const { wrapClient: assignMeClient, status } = useClient(assignMe);
  const { displaySuccess } = useSuccessMessageContext();
  const { legislationProcess } = useUserContext();
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();

  const currentLocation = useLocation();

  const handleClick = async (): Promise<void> => {
    setOpenDropdown(false);
    await assignMeClient(type, year, index, assignedList);
    reloadPripomienkaList();
    reloadFilterData();
    if (assignedList.length > 1) {
      displaySuccess('Pripomienky boli úspešne priradené.');
    } else {
      displaySuccess('Pripomienka bola úspešne priradená.');
    }
    setAssignedList([]);
  };
  return (
    <Secured
      allowForRoles={[UserRole.VYHODNOCOVATEL]}
      additionalCheck={processInCorrectStates(legislationProcess)
      && currentLocation && currentLocation.pathname.includes('zobraz')}
    >
      <li key="Označené priradiť mne" className="action-item">
        <div className="icon-wrapper">
          <img src={bookmark} className="icon" alt="Označené priradiť mne" />
        </div>
        <button
          disabled={status.loading}
          type="button"
          className="assign-me-list-button button-inline-text idsk-link"
          onClick={handleClick}
        >Označené priradiť mne
          {status.loading ? <FontAwesomeIcon className="spinner" icon={faSpinner} spin /> : null}
        </button>
      </li>
    </Secured>
  );
};

export default AssignMePripomienkaListButton;
